// extracted by mini-css-extract-plugin
export default {"wrp":"index_wrp__rLgU5","content":"index_content__ZN3K2","box":"index_box__cLdHj","link":"index_link__evC32","logo":"index_logo__11Z9G"};